module.exports = __webpack_public_path__ + "static/mixes-2.f8d4d6aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/mixes-2.jpg
// module id = 467
// module chunks = 261706647590803